import { Card, Stack, Title, Text } from '@repletoryreach/sdk-ui';
import { StatusPill } from '../../../../components/panel';
import type { flows as flowsNs } from '@repletoryreach/sdk-api';
import { formatDateTime, formatRelative, shortId } from '../../../../lib/format';
import { useT } from '../../../../i18n/I18nProvider';

type Flow = NonNullable<Awaited<ReturnType<typeof flowsNs.getFlow>>['data']>;

const MUTED = 'var(--rr-color-text-muted, #94a3b8)';

export function OverviewTab({ flow }: { flow: Flow }) {
  const t = useT();
  return (
    <Card withBorder>
      <Stack gap="sm">
        <Title order={4}>{t('flows.view.overview.title')}</Title>
        <Row label={t('common.name')} value={flow.name} />
        <Row
          label={t('common.description')}
          value={flow.description ?? <span style={{ color: MUTED }}>, </span>}
        />
        <Row
          label={t('common.status')}
          value={
            <StatusPill tone={flow.is_active ? 'active' : 'paused'}>
              {flow.is_active ? t('status.active') : t('status.inactive')}
            </StatusPill>
          }
        />
        <Row label={t('common.created')} value={`${formatDateTime(flow.created_at)} (${formatRelative(flow.created_at)})`} />
        <Row label={t('common.updated')} value={`${formatDateTime(flow.updated_at)} (${formatRelative(flow.updated_at)})`} />
        <Row label={t('flows.view.overview.flowId')} value={<code>{shortId(flow.id)}</code>} />
      </Stack>
    </Card>
  );
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '140px 1fr', gap: 8, alignItems: 'baseline' }}>
      <Text fz="xs" c={MUTED}>{label}</Text>
      <span style={{ fontSize: 14 }}>{value}</span>
    </div>
  );
}
